module.exports = __webpack_public_path__ + "img/pdf-file.603aa01a.png";